module.exports = __webpack_public_path__ + "static/assets/833fe7cec4bb3b1ec046f19ee6d13ce2.png";